export default "__VITE_ASSET__CLyIe46s__"